interface TranslationResponse {
  data: {
    translations: Array<{
      translatedText: string;
      detectedSourceLanguage?: string;
    }>;
  };
}

interface TranslationCache {
  cache: Map<string, string>;
  get(text: string): string | undefined;
  set(text: string, translation: string): void;
}

const params = {
  GOOGLE_CLOUD_TRANSLATION: {
    API_KEY: "AIzaSyCBdKYTnd8fjQ3yv4qb9GJ-2m4Sy0YyywQ",
    ENDPOINT: "https://translation.googleapis.com/language/translate/v2",
  },
};

const translationCache: TranslationCache = {
  cache: new Map<string, string>(),
  get: function (text: string) {
    return this.cache.get(text);
  },
  set: function (text: string, translation: string) {
    this.cache.set(text, translation);
  },
};

export const translateText = async (
  originalText: string,
  targetLang: string
): Promise<string> => {
  const text = (originalText as any).replaceAll(
    `
  `,
    '<span translate="no">_</span>'
  );
  // Check cache first
  const cachedTranslation = translationCache.get(`${text}-${targetLang}`);
  if (cachedTranslation) {
    return cachedTranslation;
  }

  try {
    const response = await fetch(
      `${params.GOOGLE_CLOUD_TRANSLATION.ENDPOINT}?key=${params.GOOGLE_CLOUD_TRANSLATION.API_KEY}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          q: text,
          target: targetLang,
        }),
      }
    );

    if (!response.ok) {
      throw new Error("Translation failed");
    }

    const data = await response.json();
    const unFormattedTranslation = data.data.translations[0].translatedText;
    const translation = unFormattedTranslation.replaceAll(
      '<span translate="no">_</span>',
      `
    `
    );
    // Store in cache
    translationCache.set(`${text}-${targetLang}`, translation);

    return translation;
  } catch (error) {
    throw new Error("Failed to translate text");
  }
};
